<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-1 text-gray-800">Customer Empathy</h5>
      <p class="mb-4">Paxel | Customer Excellence | Tickets | Information</p>
    </div>
    <b-card class="text-left">
      <b-row>
        <b-col>
          <h6>
            <router-link :to="{name: 'cxCorporateClaim'}">
              <i class="fas fa-arrow-left mr-1"></i>Back
            </router-link>
          </h6>
        </b-col>
      </b-row>
      <br />
      <div v-if="loading" class="d-flex justify-content-center mb-3">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
      <b-row v-else>
        <b-col md="8">
          <b-row>
            <b-col class="text-left" md="6">
              <b>Nama :</b>
              <p>{{items.name}}</p>
              <br />
              <b>No. Telp:</b>
              <p>{{items.contact}}</p>
            </b-col>
            <b-col md="6">
              <b>&nbsp;</b>
              <p>&nbsp;</p>
              <br />
              <b>Email :</b>
              <p>{{items.email}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <br />
              <b>Pesan :</b>
              <p>{{items.message}}</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <p>
            <b-button block variant="primary">
              <i class="fas fa-print"></i> Print Information
            </b-button>
          </p>
          <b-card bg-variant="light" class="text-left">
            <b-row>
              <b-col class="text-left" md="12">
                <b-form-group id="fieldset-1" label="Status" class="mb-0" label-for="input-1">
                  <b-form-select
                    v-model="items.status"
                    class="my-0"
                    :class="items.status === 'new' ? 'text-warning':'' || items.status === 'on review' ? 'text-info':''|| items.status === 'resolved' ? 'text-primary':''|| items.status === 'rejected' ? 'text-danger':'' "
                    id="input-1"
                  >
                    <option value="new" class="text-warning">New</option>
                    <option value="on review" class="text-info">On Review</option>
                    <option value="resolved" class="text-primary">Resolved</option>
                    <option value="rejected" class="text-danger">Rejected</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="8">
                <br />
                <b>Ticket No :</b>
                <p>{{items.ticket_no}}</p>
                <br />
                <b>Time Issued</b>
                <p>{{items.time_issued}}</p>
              </b-col>
              <b-col md="4" class="text-right">
                <br />
                <b>Type</b>
                <p
                  v-if="items.type == 'Feedback'"
                  class="text-success font-weight-bold"
                >{{items.type}}</p>
                <p
                  v-if="items.type == 'Complaint'"
                  class="text-warning font-weight-bold"
                >{{items.type}}</p>
                <p v-if="items.type == 'Claim'" class="text-danger font-weight-bold">{{items.type}}</p>
                <p
                  v-if="items.type == 'Information'"
                  class="text-info font-weight-bold"
                >{{items.type}}</p>
                <br />
              </b-col>
            </b-row>
          </b-card>
          <p>
            <b-button @click="putStatus()" block variant="primary">
              <i class="fas fa-save"></i> Save Change
            </b-button>
          </p>
          <br />
          <h4>Comments</h4>
          <b-button block variant="outline-primary" @click="commentShow = !commentShow">
            <i class="fas fa-plus"></i> Add Comment
          </b-button>
          <b-card
            bg-variant="light"
            v-for="item in items.comments"
            :key="item"
            class="text-left mt-4"
          >
            <b-row>
              <b-col>
                <b class="text-primary">{{item.name}}</b>
              </b-col>
              <b-col class="text-right">
                <b-link @click="del(item.id)">
                  <i class="fas fa-times text-danger"></i>
                </b-link>
              </b-col>
            </b-row>
            <p class="text-warning">{{item.date_comment}}</p>
            <p>{{item.comment}}</p>
            <p v-if="item.type_comment == 'Internal'" class="text-success font-weight-bold">Internal</p>
            <p
              v-else-if="item.type_comment == 'External'"
              class="text-danger font-weight-bold"
            >External</p>
          </b-card>
        </b-col>
        <b-col class="text-left ml-3 my-3" md="2"></b-col>
        <b-col class="my-3"></b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="commentShow"
      id="modal-prevent-closing"
      ref="modal"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      title-html="<b>New Comment</b>"
      title-tag="h4"
    >
      <b-form-group id="fieldset-1" class="text-danger" label="External" label-for="input-1">
        <b-form-textarea
          id="textarea"
          v-model="external"
          placeholder="New Comment...."
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group id="fieldset-1" class="text-success" label="Internal" label-for="input-1">
        <b-form-textarea
          id="textarea"
          v-model="internal"
          placeholder="New Comment...."
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      modalShow: false,
      commentShow: false,
      selected: null,
      loading: true,
      external: '',
      internal: '',
    };
  },
  beforeCreate() {
    this.$store.dispatch('cxCorporateClaim/getCxReport', this.$route.params.id);
  },
  mounted() {
    // Set the initial number of items
    this.$store.watch(
      state => state.cxCorporateClaim.report_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
  },
  methods: {
    changeStatus(e) {
      this.items.status = e;
    },
    putStatus() {
      this.loading = true;
      const statusData = {
        status: this.items.status,
      };
      this.$store
        .dispatch('cxCorporateClaim/putCxStatus', {
          id: this.$route.params.id,
          statusData,
        })
        .then((response) => {
          this.loading = false;
          this.$router.push({ name: 'cxCorporateClaim' });
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response;
          console.log(error);
        });
    },
    resetModal() {
      this.external = '';
      this.internal = '';
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      this.loading = true;
      const today = new Date();
      const date = `${today.getFullYear()
      }-${
        today.getMonth() + 1
      }-${
        today.getDate()}`;
      const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      const dateTime = `${date}T${time}`;
      const commentData = {
        user_id: 'admin',
        date_comment: dateTime,
        comment_internal: this.internal,
        comment_external: this.external,
      };
      this.$store
        .dispatch('cxCorporateClaim/postCxComment', {
          id: this.$route.params.id,
          commentData,
        })
        .then((response) => {
          this.loading = false;
          this.$store.dispatch('cxCorporateClaim/getCxReport', this.$route.params.id);
          this.$nextTick(() => {
            this.$refs.modal.hide();
          });
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.$nextTick(() => {
            this.$refs.modal.hide();
          });
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    del(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          const idData = {
            id: this.$route.params.id,
            comment_id: id,
          };
          this.$store
            .dispatch('cxCorporateClaim/delComment', idData)
            .then((response) => {
              this.$store.dispatch(
                'cxCorporateClaim/getCxReport',
                this.$route.params.id,
              );
              this.$swal('Deleted!', 'Your file has been deleted.', 'success');
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style>
</style>
